export interface SectorItem {
  slug: string;
  title: string;
  description: string;
}

export const sectorItems: SectorItem[] = [
  {
    slug: "healthtech",
    title: "HealthTech",
    description:
      "AI-powered patient management, clinical decision support, and HIPAA-compliant health platforms. Built for production with real patient data from 25,000+ providers.",
  },
  {
    slug: "fintech",
    title: "FinTech",
    description:
      "AI-powered underwriting assistants, document intelligence, and compliance platforms. Our RAG systems deliver 90%+ compliance accuracy in production FinTech environments where every AI response is grounded in source documents.",
  },
  {
    slug: "martech",
    title: "MarTech",
    description:
      "AI-driven monetization platforms, smart link engines, and automated content verification. We've built platforms scaling to 10,000+ users on AWS Kubernetes with 99.9% uptime.",
  },
];
